import { ReactNode, useEffect, useState } from 'react';
import { Select } from '../Select';
import { I18n } from '@/i18n/I18n';
import { ItemReferenceParams } from '@/types/itemReferenceTypes';
import { ParameterSubjectType, SelectableParameter } from '@/types/parameterTypes';

export type { SelectableParameter };

export function GenericParameterSelect(props: {
  parameters: SelectableParameter[],
  currentParameter?: SelectableParameter,
  currentReference?: ItemReferenceParams,
  createReference: (parameter: SelectableParameter) => void,
  deleteReference: (referenceId?: string) => void,
  children?: ReactNode,
  blockSelectNone?: boolean
 }) {
  const { parameters, currentParameter, currentReference, createReference, deleteReference, children, blockSelectNone } = props;
  const [dropdownValue, setDropdownValue] = useState<string | ReactNode>(I18n.get('none'));

  useEffect(() => {
    if (currentParameter?.subjectType === ParameterSubjectType.IMPLEMENTATION) {
      setDropdownValue(<>{currentParameter.title} <span className="badge bg-secondary ms-1">{I18n.get('properties')}</span></>);
    } else {
      setDropdownValue(currentParameter?.title || I18n.get('none'));
    }
  }, [currentParameter]);

  const onCreateReference = (parameter: SelectableParameter) => {
    if (currentReference) {
      deleteReference(currentReference.id);
    }
    createReference(parameter);
  };

  const selectableParameters = parameters.filter(param => !(param.id === currentParameter?.id && param.keyId === currentParameter?.keyId));

  return (
    <Select value={dropdownValue} label={I18n.get('selectParameter')}>
      {selectableParameters.map(param => (
         <button type="button" key={`${param.id}-${param.keyId}`} className="w-100 dropdown-item text-wrap" onClick={() => onCreateReference(param)}>
           {param.title}
           {param.subjectType === 'implementation' && <span className="badge bg-secondary ms-2">{I18n.get('properties')}</span>}
         </button>
      ))}
      { currentParameter && !blockSelectNone && <button type="button" className="w-100 dropdown-item" onClick={() => deleteReference(currentReference?.id)}>{I18n.get('none')}</button> }
      { children }
    </Select>
  );
}
